import { render, staticRenderFns } from "./WizardPage2.vue?vue&type=template&id=09a3ee5c"
import script from "./WizardPage2.vue?vue&type=script&lang=js"
export * from "./WizardPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports